import { Component, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { EventEmitter } from '@angular/core';
import { ModalPopupType } from '../../models/modalPopupType';
import { reject } from 'lodash';


@Component({
  selector: 'modal-signupwarning-popup',
  templateUrl: './modal-signupwarning-popup.component.html',
  styleUrls: ['./modal-signupwarning-popup.component.scss']
})
export class ModalSignupwarningPopupComponent implements OnInit {

    @ViewChild('template') template: TemplateRef<any>;
    @Output() clickedYes = new EventEmitter<any>();
    @Output() clickedCancel = new EventEmitter<any>();
    @Input() message: string;
    @Input() submessage: string;
    modalType: ModalPopupType;
    modalRef: BsModalRef;
    config = {
        animated: true,
        class: 'modal-dialog-centered'
    };

    constructor(private bsModalService: BsModalService) { }

    ngOnInit(): void {
    }

    show() {
        this.modalRef = this.bsModalService.show(this.template, this.config)
    }

    yes() {
        this.clickedYes.emit();
        this.modalRef.hide();
    }

    cancel() {
        this.modalRef.hide();
    }

}
